// Patchistry cart receiver synchronization.
// Shopify Ajax Cart remains authoritative; this file only projects its state
// into custom storefront receivers and emits one canonical read event.
(function () {
  'use strict';

  if (window.PatchistryCartState) return;

  let currentCart = null;
  let refreshPromise = null;
  let dawnUnsubscribe = null;

  function normalizeCart(cart) {
    const source = cart && typeof cart === 'object' ? cart : {};
    const itemCount = Math.max(0, Math.trunc(Number(source.item_count) || 0));
    const totalPrice = Math.max(0, Math.trunc(Number(source.total_price) || 0));
    return {
      ...source,
      item_count: itemCount,
      total_price: totalPrice,
      items: Array.isArray(source.items) ? source.items : [],
    };
  }

  function greetingForCart(rawCart) {
    const cart = normalizeCart(rawCart);
    if (cart.item_count > 0) {
      const topItems = cart.items.slice(0, 4).map((item) => item.title).filter(Boolean).join(', ');
      const moreCount = cart.items.length > 4 ? ` (+${cart.items.length - 4} more)` : '';
      const total = (cart.total_price / 100).toFixed(2);
      return `Awesome setup! I see you've got ${topItems}${moreCount} in your build ($${total}). Want to finish your layout now, or should I email this configuration to you so you don't lose it?`;
    }
    return "Ready to build something unique? Tell me the occasion (bach party, golf day, outdoor adventure, or custom gift) and let's construct a premium layout!";
  }

  function updateHeader(cart) {
    const itemCount = cart.item_count;
    const cartLink = document.querySelector('.p-header-cart');
    const drawerCartCount = document.querySelector('[data-patchistry-drawer-cart-count]');

    if (cartLink) {
      cartLink.setAttribute('aria-label', `Cart, ${itemCount} item${itemCount === 1 ? '' : 's'}`);
      let badge = cartLink.querySelector('.p-header-cart-badge');
      if (itemCount > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'p-header-cart-badge';
          badge.setAttribute('aria-hidden', 'true');
          cartLink.appendChild(badge);
        }
        badge.textContent = String(itemCount);
      } else if (badge) {
        badge.remove();
      }
    }

    if (drawerCartCount) {
      drawerCartCount.textContent =
        itemCount > 0 ? `${itemCount} item${itemCount === 1 ? '' : 's'}` : 'Cart';
    }

    document
      .querySelectorAll('[data-cart-count], .cart-count, .header__cart-count, #CartCount')
      .forEach((element) => {
        element.textContent = String(itemCount);
      });
  }

  function sync(rawCart, source = 'direct') {
    const cart = normalizeCart(rawCart);
    currentCart = cart;
    updateHeader(cart);
    window.dispatchEvent(new CustomEvent('patchistry:cart-state', {
      detail: { cart, source },
    }));
    return cart;
  }

  function cartUrl() {
    const root = window.Shopify?.routes?.root || '/';
    return `${root.endsWith('/') ? root : `${root}/`}cart.js`;
  }

  function refresh(source = 'refresh') {
    if (refreshPromise) return refreshPromise;
    refreshPromise = fetch(cartUrl(), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
    })
      .then((response) => {
        if (!response.ok) throw new Error('cart read failed');
        return response.json();
      })
      .then((cart) => sync(cart, source))
      .catch(() => null)
      .finally(() => {
        refreshPromise = null;
      });
    return refreshPromise;
  }

  function cartFromSignal(event) {
    const detail = event?.detail;
    if (detail?.cart && typeof detail.cart === 'object') return detail.cart;
    if (detail?.cartData && typeof detail.cartData === 'object') return detail.cartData;
    if (detail && typeof detail.item_count !== 'undefined') return detail;
    return null;
  }

  function receiveSignal(event) {
    const cart = cartFromSignal(event);
    if (cart) {
      sync(cart, event?.type || 'signal');
    } else {
      refresh(event?.type || 'signal');
    }
  }

  function bindDawnCartEvents() {
    try {
      if (
        !dawnUnsubscribe &&
        typeof subscribe === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.cartUpdate
      ) {
        dawnUnsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, receiveSignal);
      }
    } catch (_) {}
  }

  function init() {
    bindDawnCartEvents();
    refresh('init');
  }

  document.addEventListener('cart:updated', receiveSignal);
  window.addEventListener('patchistry:cart-updated', receiveSignal);
  window.addEventListener('patchistry:cart-count', receiveSignal);
  window.addEventListener('pageshow', () => refresh('pageshow'));

  window.PatchistryCartState = Object.freeze({
    getCurrent() {
      return currentCart;
    },
    greetingForCart,
    refresh,
    sync,
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
